import { Button, ButtonGroup } from '@chakra-ui/react';
import { NavLink, useLocation } from 'react-router-dom';
import React, { useEffect, useMemo, useState } from 'react';
import { getIsImpersonating, getIsPreferredReportsRole, getIsSearchOnlyRole } from '@/redux/app-selectors';
import { getAdminTabPath, getHideSubTabs, getHideTabs } from '@/utils/utils';

interface NavigationProps {
  isGlobalAdmin: boolean;
  isStoreAdmin: boolean;
  isGlobalOperations: boolean;
  onClick?: () => void;
  isGlobalAdminRole: boolean
  userPermissions: any
  isStoreAgent: boolean
}

export default function Navigation({ isGlobalAdmin, isStoreAdmin, isGlobalOperations, userPermissions, isStoreAgent, onClick, isGlobalAdminRole }: NavigationProps) {
  const [isChangeMenuForMobile, setisChangeMenuForMobile] = useState(false);
  const [storeAdminPathId, setStoreAdminPathId] = useState<string | null>(null);
  const [globalAdminPathId, setGlobalAdminPathId] = useState<string | null>(null);
  const screenResolution = window.innerWidth > 1024;
  const { pathname } = useLocation();
  const isPreferredReportsRole = getIsPreferredReportsRole();
  const isSearchOnlyRole = getIsSearchOnlyRole();
  const isImpersonating = getIsImpersonating();
  const savedUserPermissions = JSON.parse(localStorage.getItem('savedUserPermissions') || '{}');

  useEffect(() => {
    if (pathname) {
      let pathId = pathname.split('/admin/')[1];
      const permissions = Object.keys(userPermissions).length === 0 ? savedUserPermissions : userPermissions;
      const subTabs = getHideSubTabs(isStoreAdmin, isStoreAgent, permissions)
      
      if(subTabs && subTabs.length > 0){
        const path = getAdminTabPath(subTabs, pathId)
        pathId = path.split('/admin/')[1];
      }
      
      const mainRoute = pathId?.match(/^[^\/]+/)?.[0];
      
      if (isStoreAdmin) setStoreAdminPathId(mainRoute || null)
      if (isGlobalAdmin) setGlobalAdminPathId(mainRoute || null)
    }
  }, [pathname])
  const otherUsersLinks = [
    ...(!isChangeMenuForMobile && !isPreferredReportsRole && !isSearchOnlyRole ? [{
      label: 'Transfer Queue',
      route: '/transfers'
    }] : []),
    {
      label: 'Search',
      route: '/dealers-search'
    },
    ...((isStoreAdmin || isPreferredReportsRole) ? [{
      label: 'Admin',
      route: `/admin/${storeAdminPathId || (isPreferredReportsRole ? 'upload-preferred-dealers' : 'manage-dealer-profile')}`
    }] : []),
    ...((isGlobalAdmin || isGlobalOperations)
      ? [
        {
          label: 'Admin',
          route: `/admin/${globalAdminPathId || (isGlobalOperations ? 'license-approval' : 'stores')}`
        }
      ]
      : []),

  ];

  const getLinks = () => {
    const navigationLinks = [];
    const permissions = Object.keys(userPermissions).length === 0 ? savedUserPermissions : userPermissions;
    if((isStoreAdmin|| isStoreAgent )&&  permissions && Object.keys(permissions)?.length == 0){
      return []
    } 
    const hideTabs = getHideTabs( isStoreAdmin, isStoreAgent, permissions);
    // Transfer Queue link
    if ((!isChangeMenuForMobile && !isGlobalOperations && !isPreferredReportsRole && !isSearchOnlyRole && !hideTabs.includes('transfer'))) {
      navigationLinks.push({
        label: 'Transfer Queue',
        route: '/transfers'
      });
    }

    // Search link - always visible
    if (!hideTabs.includes('dealerSearch')) {
      navigationLinks.push({
        label: 'Search',
        route: '/dealers-search'
      });
    }

    // Store Admin or Preferred Reports Admin link
    if ( isPreferredReportsRole || (!hideTabs.includes('admin') && isStoreAdmin)) {
      navigationLinks.push({
        label: 'Admin',
        route: `/admin/${storeAdminPathId || (isPreferredReportsRole ? 'upload-preferred-dealers' : 'manage-dealer-profile')}`
      });
    }

    // Global Admin or Operations link
    if (isGlobalAdmin || isGlobalOperations) {
      navigationLinks.push({
        label: 'Admin',
        route: `/admin/${globalAdminPathId || (isGlobalOperations ? 'license-approval' : 'stores')}`
      });
    }

    return navigationLinks;
  };
  const links = ((isStoreAdmin || isStoreAgent) && !isImpersonating) ? getLinks() : otherUsersLinks;
  
  useEffect(() => {
    if (window.innerWidth < 744)
      setisChangeMenuForMobile(true)
  }, [])

  return (
    <ButtonGroup className={'Navigation'} variant="ghost-on-accent" spacing="1">
      {links.map((tab, i) => (
        <NavLink key={i} to={tab.route} onClick={onClick}>
          {({ isActive }) => (
            <Button className={isActive ? 'btn-border' : ''} _hover={{ borderColor: '#ccd0d5', bg: isActive && screenResolution ? '#ebedf0' : '', color: isActive && screenResolution ? '#0C1E46' : '#ebedf0' }} variant={isActive && screenResolution ? 'outline' : ''}>{tab.label}</Button>
          )}
        </NavLink>
      ))}
    </ButtonGroup>
  );
}
